import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Action(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props} viewBox="0 0 48 48">
      <rect x="10.251" y="29.6104" width="18.5934" height="4.82051" fill="#80D7FD" />
      <circle cx="24.3797" cy="15.4954" r="9.2967" fill="#A67DFB" />
      <path
        d="M20.4872 15.8232L20.3573 15.7482L20.4323 15.6183L26.6597 4.83218L26.7347 4.70228L26.8646 4.77728L36.3816 10.272L36.5115 10.347L36.4365 10.4769L30.2092 21.2629L30.1342 21.3928L30.0043 21.3178L20.4872 15.8232ZM21.768 15.3702L29.7562 19.9822L35.1009 10.7249L27.1127 6.11293L21.768 15.3702Z"
        fill="#202020"
        stroke="#202020"
        strokeWidth="0.3"
      />
      <path
        d="M36.1819 11.3484L26.0303 5.48742C25.0841 4.94109 24.7586 3.7272 25.3052 2.78045L26.0378 1.51149C26.5843 0.564975 27.7983 0.239904 28.7446 0.786227L38.8961 6.64723C39.8424 7.19355 40.168 8.4072 39.6214 9.35397L38.8886 10.6232C38.3422 11.5697 37.1282 11.8948 36.1819 11.3484ZM38.7271 8.83763C38.9886 8.38469 38.8328 7.80307 38.3798 7.54155L28.2282 1.68054C27.7753 1.41904 27.1937 1.57487 26.9321 2.02783L26.1995 3.29679C25.938 3.74973 26.0938 4.33135 26.5468 4.59287L36.6984 10.4539C37.1513 10.7154 37.7329 10.5596 37.9944 10.1066L38.7271 8.83763Z"
        fill="#202020"
        stroke="#202020"
        strokeWidth="0.3"
      />
      <path
        d="M28.1234 25.3062L17.9719 19.4452C17.0256 18.8989 16.7001 17.685 17.2466 16.7385L17.9792 15.4695C18.5257 14.523 19.7397 14.1979 20.686 14.7442L30.8375 20.6052C31.7838 21.1516 32.1094 22.3652 31.5628 23.312L30.8302 24.5809C30.2837 25.5275 29.0697 25.8525 28.1234 25.3062ZM30.6686 22.7954C30.9301 22.3425 30.7743 21.7608 30.3213 21.4993L20.1698 15.6383C19.7168 15.3768 19.1352 15.5326 18.8737 15.9856L18.1411 17.2546C17.8795 17.7075 18.0354 18.2891 18.4883 18.5506L28.6399 24.4117C29.0928 24.6732 29.6745 24.5173 29.936 24.0644L30.6686 22.7954Z"
        fill="#202020"
        stroke="#202020"
        strokeWidth="0.3"
      />
      <path
        d="M31.2016 17.7781L31.0717 17.7031L31.1467 17.5732L33.7102 13.1318L33.7851 13.0019L33.9151 13.0769L48.8252 21.6852C50.1212 22.4335 50.5668 24.0967 49.8186 25.3927C49.0703 26.6888 47.4071 27.1344 46.1111 26.3861L31.2016 17.7781ZM48.9245 24.8762C49.3881 24.0732 49.1118 23.0427 48.309 22.5793L34.1635 14.412L32.4819 17.3246L46.6275 25.4916C47.4303 25.9551 48.4607 25.6794 48.9245 24.8762Z"
        fill="#202020"
        stroke="#202020"
        strokeWidth="0.3"
      />
      <path
        d="M30.8209 34.5336H14.7035C13.6106 34.5336 12.7218 33.6451 12.7221 32.5521C12.7221 32.5521 12.7221 32.5521 12.7221 32.5521V31.0868C12.7221 29.9939 13.6109 29.1054 14.7035 29.1054H30.8209C31.9135 29.1054 32.8023 29.9936 32.8023 31.0868V32.5521C32.8023 33.6451 31.9135 34.5336 30.8209 34.5336ZM31.7697 31.0866C31.7697 30.5636 31.3439 30.1378 30.8209 30.1378H14.7035C14.1805 30.1378 13.7547 30.5635 13.7547 31.0866V32.5518C13.7547 33.0749 14.1805 33.5006 14.7035 33.5006H30.8209C31.3439 33.5006 31.7697 33.0749 31.7697 32.5518V31.0866Z"
        fill="#202020"
        stroke="#202020"
        strokeWidth="0.3"
      />
      <path
        d="M10.3154 13.3472L7.85138 12.1158M5.38733 10.8845L6.00334 11.1924"
        stroke="#202020"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9333 9.49686L10.4666 4.57034"
        stroke="#202020"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0081 19.3527L3.38655 18.7383"
        stroke="#202020"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0868 24.1258L7.39142 25.3585"
        stroke="#202020"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconWrapper>
  );
}
